import { NumberValue } from '@heroui-pro/react';
import { KPI } from '@heroui-pro/react/kpi';
import type { RevenueDynamics } from '@/api/models';
import { formatGel } from '@/utils';
import type { RevenueDynamicsKpiSlot } from './revenueDynamicsMeta';

/** Formats the typed value of a revenue KPI; money uses its tetri twin. */
type RevenueDynamicsKpiValueProps = {
    slot: RevenueDynamicsKpiSlot;
    data: RevenueDynamics;
};

export const RevenueDynamicsKpiValue = ({
    slot,
    data,
}: RevenueDynamicsKpiValueProps) => {
    switch (slot) {
        case 'totalRevenue':
            return (
                <KPI.Value value={data.summary.totalRevenue}>
                    {/* `formatGel` on the tetri twin, not Intl's currency style: the latter renders `GEL 455` while every other money figure in the app renders `₾ 455` (BOS-171). */}
                    {() => formatGel(data.summary.totalRevenueTetri)}
                </KPI.Value>
            );
        case 'totalDiscounts':
            return (
                <KPI.Value value={data.summary.totalDiscounts}>
                    {() => formatGel(data.summary.totalDiscountsTetri)}
                </KPI.Value>
            );
        case 'totalMarkup':
            return (
                <KPI.Value value={data.summary.totalMarkup}>
                    {/* `formatGel` on the tetri twin, not Intl's currency style: the latter renders `GEL 455` while every other money figure in the app renders `₾ 455` (BOS-171). */}
                    {() => formatGel(data.summary.totalMarkupTetri)}
                </KPI.Value>
            );
        case 'marginPercent':
            return (
                <KPI.Value
                    maximumFractionDigits={0}
                    style="decimal"
                    value={data.summary.marginPercent}
                >
                    <NumberValue.Suffix>%</NumberValue.Suffix>
                </KPI.Value>
            );
        case 'transactions':
            return (
                <KPI.Value
                    maximumFractionDigits={0}
                    style="decimal"
                    value={data.summary.transactions}
                />
            );
        case 'averageReceipt':
            return (
                <KPI.Value value={data.summary.averageReceipt}>
                    {/* `formatGel` on the tetri twin, not Intl's currency style: the latter renders `GEL 455` while every other money figure in the app renders `₾ 455` (BOS-171). */}
                    {() => formatGel(data.summary.averageReceiptTetri)}
                </KPI.Value>
            );
    }
};
